export default __webpack_public_path__ + "static/media/14_Visit-a-river.913bb805.jpg";